import React from 'react';
import '../../App.css';

const Footer = () => (
  <section className="footer-wrapper">
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1: Logo & Description */}
        <div className="footer-column">
          <div className="footer-logo">
            <img src="../../assets/images/webp/aelogo.webp" alt="Admission Express"className="footer-logo-img"  />
            <span className="logo-text">AdmissionsExpress</span>
            <p>At AdmissionsExpress.com, our mission is to unlock opportunities for students globally...</p>
          </div>
        </div>

        {/* Column 2: Links */}
        <div className="footer-column">
          <h4>Useful Links</h4>
          <ul className="footer-links">
            <li><a href="/#home">Home</a></li>
            <li><a href="/#aboutus">About Us</a></li>
            <li><a href="/#ourservices">Services</a></li>
            <li><a href="/#studentservices">Student Services</a></li>
            <li><a href="/#englishtest">English Test</a></li>
            <li><a href="/#contact">Contact Us</a></li>
          </ul>
        </div>

        {/* Column 3: Contact */}
        <div className="footer-column">
          <h4>Contact Us</h4>
          <p><i className="fa fa-map-marker"></i> USA : Scottsdale, AZ</p>
          <p><i className="fa fa-phone"></i> <a href="tel:+1(623)212-3507">+1(623)212-3507</a></p>
          <p><i className="fa fa-envelope"></i> <a href="mailto:info@admissionsexpress.com">info@admissionsexpress.com</a></p>
          <div className="footer-social-icons">
            <a href="https://www.youtube.com/@xvantechLLC-arizona" target="_blank" rel="noreferrer"><i className="fab fa-youtube"></i></a>
            <a href="https://instagram.com/admissions_express" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
            <a href="https://facebook.com/share/19sKmWjYwB/" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f"></i></a>
            <a href="https://tiktok.com/@admission.express" target="_blank" rel="noreferrer"><i className="fab fa-tiktok"></i></a>

          </div>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Admissions Express. All rights reserved.
      </div>
    </footer>
  </section>
);

export default Footer;
